import { generateClient } from 'aws-amplify/api';
import { getCurrentUser } from 'aws-amplify/auth';
import * as mutations from '../graphql/mutations';
import * as queries from '../graphql/queries';

const client = generateClient();

export const getPathfinderRadiologyDomainKeyByIndex = (index) => {
  const domainKeys = [
    "Commitment to Specialty (double-weighted domain)",
    "Leadership and Management (minimum role duration 6 months)",
    "Teaching and Training",
    "Audit and Quality Improvement",
    "Academic Achievements (postgraduate achievements only for scoring)"
  ];
  
  const numericIndex = Number(index);
  if (isNaN(numericIndex)) {
    return `Unknown domain ${index}`;
  }
  
  return domainKeys[numericIndex] || `Unknown domain ${index}`;
};

const isNumericDomainKey = (key) => {
  return !isNaN(Number(key)) && key !== null && key !== '';
};

export const savePathfinderRadiologyDomainScore = async (domainKey, points) => {
  try {
    const textDomainKey = isNumericDomainKey(domainKey) 
      ? getPathfinderRadiologyDomainKeyByIndex(Number(domainKey))
      : domainKey;
    
    const user = await getCurrentUser();
    if (!user) throw new Error('User not authenticated');

    console.log(`Saving PathfinderRadiologyDomainScore: domainKey="${textDomainKey}", points=${points}`);

    const { data } = await client.graphql({
      query: queries.listPathfinderRadiologyDomainScores,
      variables: {
        filter: { 
          userId: { eq: user.username }, 
          domainKey: { eq: textDomainKey }
        }
      },
      authMode: 'userPool'
    });

    const existingRecord = data.listPathfinderRadiologyDomainScores.items[0];

    if (existingRecord) {
      const input = {
        id: existingRecord.id,
        userId: user.username,
        domainKey: textDomainKey,
        progress: points,
        owner: user.username,
        _version: existingRecord._version
      };

      console.log('Updating existing Radiology record with input:', input);
      const result = await client.graphql({
        query: mutations.updatePathfinderRadiologyDomainScore,
        variables: { input },
        authMode: 'userPool'
      });
      
      console.log('Radiology Update successful:', result);
      return result;
    } else {
      const input = {
        userId: user.username,
        domainKey: textDomainKey,
        progress: points,
        owner: user.username
      };

      console.log('Creating new Radiology record with input:', input);
      const result = await client.graphql({
        query: mutations.createPathfinderRadiologyDomainScore,
        variables: { input },
        authMode: 'userPool'
      });
      
      console.log('Radiology Create successful:', result);
      return result;
    }
  } catch (error) {
    console.error('Error saving Pathfinder Radiology domain score:', error);
    throw error;
  }
};

export const fetchAllPathfinderRadiologyDomainScores = async () => {
  try {
    const user = await getCurrentUser();
    if (!user) throw new Error('User not authenticated');

    const { data } = await client.graphql({
      query: queries.listPathfinderRadiologyDomainScores,
      variables: {
        filter: { userId: { eq: user.username } },
        limit: 100
      },
      authMode: 'userPool'
    });

    return data.listPathfinderRadiologyDomainScores.items;
  } catch (error) {
    console.error('Error fetching Pathfinder Radiology domain scores:', error);
    return [];
  }
};
